import zod from 'zod';

export type RollupPropertyData = {
  _v: 1;
  sourceRelationPropertyId: string | null;
  targetPropertyId: string | null;
  aggregationType: string | null;
};

export const ROLLUP_PROPERTY_TYPE = 'orghub-rollup' as const;

export type RollupRawValue = null;

// Fast custom schemas — see relation/types.ts for rationale.
export const RollupPropertySchema = zod.custom<RollupPropertyData>(
  v => typeof v === 'object' && v !== null
);
export const RollupRawValueSchema = zod.custom<RollupRawValue>(v => v === null);
